import React from 'react';
import { Tooltip, Typography } from '@mui/material';
import { OverflowChips } from '@/components/OverflowChips';
import { OwnerCellData } from '@/components/tables/OwnerCell';
import {
	formatDateTime,
	getDateSortValue,
} from '@/components/views/SettingsView/BrokerageUsersTable/helpers';
export const columns = [
	{
		field: 'name',
		headerName: 'Name',
		flex: 1,
		minWidth: 180,
		hideable: false,
	},
	{
		field: 'contactEmail',
		headerName: 'Email',
		flex: 1.2,
		minWidth: 200,
		hideable: false,
	},
	{
		field: 'phoneNumber',
		headerName: 'Phone',
		flex: 1.2,
		minWidth: 200,
		hideable: false,
	},
	{
		field: 'users',
		headerName: 'Users',
		flex: 1.4,
		minWidth: 240,
		sortable: false,
		display: 'flex',
		hideable: true,
		renderCell: ({ row }) => {
			const users = row.users ?? [];
			if (!users.length) {
				return <Typography variant='body1'>-</Typography>;
			}

			return (
				<Tooltip title={users.map((user) => user.name).filter(Boolean).join(', ')}>
					<OverflowChips
						items={users}
						limitTags={3}
						width='100%'
						height='100%'
						getLabel={(user) => user.name ?? user.email ?? ''}
					/>
				</Tooltip>
			);
		},
	},
	{
		field: 'lastUpdated',
		headerName: 'Last updated',
		width: 190,
		display: 'flex',
		type: 'number',
		headerAlign: 'left',
		hideable: true,
		valueGetter: (_, row) => getDateSortValue(row.lastUpdated),
		renderCell: ({ row }) => formatDateTime(row.lastUpdated),
	},
	{
		field: 'claimsEmail',
		headerName: 'Claims email',
		flex: 1.2,
		minWidth: 200,
		hideable: true,
	},
	{
		field: 'website',
		headerName: 'Website',
		flex: 1.2,
		minWidth: 180,
		hideable: true,
	},
	{
		field: 'fspNumber',
		headerName: 'FSP / AFS',
		width: 130,
		hideable: true,
	},
	{
		field: 'address',
		headerName: 'Address',
		flex: 1.4,
		minWidth: 220,
		hideable: true,
	},
	{
		field: 'country',
		headerName: 'Country',
		width: 110,
		hideable: true,
	},
	{
		field: 'ledger',
		headerName: 'Ledger',
		width: 140,
		hideable: true,
	},
	{
		field: 'lastUpdatedBy',
		headerName: 'Last updated by',
		flex: 1,
		minWidth: 180,
		sortable: false,
		display: 'flex',
		hideable: true,
		renderCell: ({ row }) =>
			row.lastUpdatedBy ? (
				// lastUpdatedBy is the performer's Firestore user doc id.
				<OwnerCellData userId={row.lastUpdatedBy} color='text.primary' />
			) : (
				<Typography variant='body1'>-</Typography>
			),
	},
].map((column) => ({ ...column, disableColumnMenu: !column.hideable }));
